import React, { useState } from 'react';
import ComplianceCard from './ComplianceCard';
import { cardData } from './ComplianceCardData'; // Ensure this is correctly imported
import SingleUserLayout from '../SingleUserLayout';
import CACUpload from './CAC/CACUpload';
import BvnUpload from './BVN/BvnUpload';
import NINUpload from './NIN/NINUpload';
import { useSelector } from 'react-redux';
import RootState from '../../../../../../redux/types';
import EmptyScreen from '../../../../../../components/common/emptyScreen';
import Skeleton from 'react-loading-skeleton';

const ComplianceCardList = () => {
	const [rcNumber, setRcNumber] = useState<string>('');
	const [businessEmail, setBusinessEmail] = useState<string>('');
	const [id, setBusinessId] = useState<string | number>('');
	const [businessName, setBusinessName] = useState<string>('');
	const [businessAddress, setBusinessAddress] =
		useState<string>('Default Address');
	const [businessaType, setBusinessaType] = useState<string>('Retail');
	const [businessStatus, setBusinessStatus] = useState<string>('Active');
	const [date, setDate] = useState<string>(new Date().toISOString());
	const [imageUrl, setImageUrl] = useState<string>(
		'https://default-image-url.com'
	);

	return (
		<>
			<BvnUpload onRevoke={() => 'Revoke action triggered'} />
			<NINUpload onRevoke={() => 'Revoke action triggered'} />
			{/* <ComplianceCard onRevoke={() => 'Revoke action triggered'} /> */}
			<CACUpload onRevoke={() => 'Revoke action triggered'} />
		</>
	);
};

export default ComplianceCardList;
